import { render } from "./email-verified.vue?vue&type=template&id=3605d362&scoped=true"
import script from "./email-verified.vue?vue&type=script&lang=js"
export * from "./email-verified.vue?vue&type=script&lang=js"

import "./email-verified.vue?vue&type=style&index=0&id=3605d362&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3605d362"]])

export default __exports__